export const VariantsWithClear = ['GreyOutlinedClear', 'GreyOutlinedPillClear'];
export const KEY_SPACE = ' ';
export const KEY_ENTER = 'Enter';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEY_HOME = 'Home';
export const KEY_END = 'End';
export const KEY_ESCAPE = 'Escape';
//# sourceMappingURL=BKJSelect.constants.js.map